"use client";

import { useMemo } from "react";
import { StickyBanner } from "./sticky-banner";
import { homeStickyBannerSlides } from "../../_utils/sticky-banner";
import { QUIZ_VARIANT_TEST_A, QUIZ_VARIANT_TEST_B } from "@/lib/utils/common/constants";
import { useQuizTouchpointImpressionVisible } from "@/components/quiz/hooks/use-quiz-touchpoint-impression";

export function HomeStickyBanner({ variant }: { variant?: string | null }) {
  const hasQuiz = variant === QUIZ_VARIANT_TEST_A || variant === QUIZ_VARIANT_TEST_B;

  const slides = useMemo(() => {
    if (!hasQuiz) {
      return homeStickyBannerSlides.filter((slide) => slide.id !== "quiz");
    }
    return homeStickyBannerSlides;
  }, [hasQuiz]);

  useQuizTouchpointImpressionVisible("top_strip", hasQuiz);

  return <StickyBanner slides={slides} />;
}
